import { LegalLayout } from "@/pages/LegalLayout";

const CONDITIONS = [
  "The refund request must be submitted within seven calendar days of the original transaction.",
  "The guarantee applies only to products or services specifically identified as guarantee-eligible at checkout.",
  "Work already completed, delivered, consumed, downloaded, licensed, or approved may be excluded from a full refund where permitted by applicable law and disclosed before purchase.",
  "Advertising spend, third-party software, domain registrations, hosting, platform charges, transaction fees, printing, purchased media, and other nonrecoverable third-party expenses are not refundable by All In Hand Marketing.",
  "Custom software, custom creative work, consulting already delivered, and projects that have entered substantial production may be subject to separate cancellation/refund terms stated in the applicable proposal or agreement.",
  "Customers must provide sufficient purchase information for the transaction to be located.",
  "Refunds, when approved, are returned through the applicable payment method or payment processor according to its processing timelines.",
  "Nothing in this policy limits rights that cannot legally be waived under applicable consumer-protection law.",
];

export default function RefundPolicyPage() {
  return (
    <LegalLayout title="Refund Policy">
      <p>
        Eligible All In Hand Marketing purchases are protected by our 7-Day Money-Back Guarantee. If
        you purchase an eligible service or digital product and determine that it is not right for
        you, you may submit a refund request within 7 calendar days of the original purchase date,
        subject to the conditions below.
      </p>

      <div>
        <h2 className="font-display text-xl font-bold text-white mb-4">Guarantee Conditions</h2>
        <ul className="space-y-3">
          {CONDITIONS.map((c, i) => (
            <li key={i} className="flex gap-3">
              <span className="w-1.5 h-1.5 rounded-full bg-gold mt-2.5 shrink-0" />
              <span>{c}</span>
            </li>
          ))}
        </ul>
      </div>

      <p>
        Always review the applicable service agreement, checkout terms, and refund conditions before
        purchasing. This page summarizes the guarantee that applies to offer-page purchases; where a
        signed proposal or agreement applies, its terms govern that engagement. Questions about
        eligibility? Contact{" "}
        <a href="mailto:allinhand@zohomail.com" data-testid="refund-contact-email" className="text-gold underline underline-offset-2">
          allinhand@zohomail.com
        </a>
        .
      </p>
    </LegalLayout>
  );
}
